import { Component, OnInit, Inject, Injector } from '@angular/core';
import { organizationI } from 'app/core/interfaces/organization';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { addressI } from 'app/core/interfaces/adress';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { DialogData } from 'app/core/interfaces/dialog';
import { CurrentUser } from 'app/core/interfaces/currentUser';
import { BaseComponent } from 'app/modules/shared/components/base.component';

@Component({
  selector: 'page-organization-details',
  templateUrl: './organization-details.component.html',
  styleUrls: ['./organization-details.component.scss']
})
export class OrganizationSecretariesDetailsComponent extends BaseComponent implements OnInit {

  public organization: organizationI|undefined = <organizationI>{};
  public address:addressI = <addressI>{};
  public titles = ['Qualificações', 'Cursos/Certificados', 'Idiomas'];
  public checked = true;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector 
  ) { 
    super(injector);
  }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {

  
    if (this.data.param.location) {
      this.address = this.formatAddress(this.data.param.location);
    }


    /** 
    //@TODO GET organization details
    if (this.data.param.location) {
     
     
     this.organization = this.auth.getFromLocalStorage('organizations').find((item:organizationI) => item.id == this.data.param.id);
      if (this.organization) {
        this.address = this.organization.address;
        this.checked = this.organization.active;
      }
    }*/
  }

  formatAddress(address : any ) {

    const extraInfos = address?.line ?? [];

    return {
      cep: address.postalCode,
      city: address.city,
      country: address.country,
      state: address.state,
      street: extraInfos[0] ?? '',
      number: extraInfos[1] ?? '',
      complement: extraInfos[2] ?? '',

    }



  }

  

}
